export enum DeviceMotion {
  // eslint-disable-next-line no-unused-vars
  UNSUPPORTED,
  // eslint-disable-next-line no-unused-vars
  SUPPORTED,
  // eslint-disable-next-line no-unused-vars
  ENABLED,
}
